import { h, createApp } from 'vue'
import type { App } from 'vue'
import Video from './Video.vue'
import useVideoList from './useVideoList'

type VideoType = {
  src: string
  alt?: string
  poster?: string
}

export default function showVideoList(videoList: VideoType[], initIndex = 0) {
  let container: HTMLElement | null = document.createElement('div')
  document.body.appendChild(container)

  let app: App<Element> | null = null

  const {
    currentVideo, handlePrev, handleNext
  } = useVideoList<VideoType>(videoList, initIndex)

  function destroy() {
    if (!app || !container) {
      return
    }
    app.unmount()
    document.body.removeChild(container)
    app = null
    container = null
  }

  app = createApp({
    setup() {
      return () => h(
        <Video
          allow-full={false}
          poster={currentVideo.value?.poster}
          src={currentVideo.value?.src}
          alt={currentVideo.value?.alt}
          fullscreen={true}
          handelExitFull={destroy}
          handleNext={handleNext.value}
          handlePrev={handlePrev.value}
        />
      )
    }
  })

  app.mount(container)
  return {
    destroy
  }
}